<template>
    <input v-if="is_mobile" type="time" v-model="model">
    <input v-else ref="text" type="text" v-model="model">
</template>

<script>
import Inputmask from "inputmask";
export default {
    props: ['value'],
    data() {
        return {
            model: null,
            picker: null
        }
    },

    mounted() {
        this.model = this.value
        if(!this.is_mobile) {
            Inputmask({"mask": "99:99"}).mask(this.$refs.text);
        }
    },

    computed: {
        is_mobile() {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
        }
    },

    watch: {

        model(value) {
            this.$emit('input', value)
        }

    }

}
</script>
